var _g;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgX(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "x",
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.99,
    height: 27.99,
    viewBox: "0 0 27.99 27.99",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_55686",
    "data-name": "Group 55686",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_87441",
    "data-name": "Path 87441",
    d: "M16.323,14,27.507,2.815A1.646,1.646,0,1,0,25.179.487L14,11.671,2.811.487A1.646,1.646,0,1,0,.483,2.815L11.667,14,.483,25.183a1.646,1.646,0,1,0,2.328,2.328L14,16.327,25.179,27.511a1.646,1.646,0,0,0,2.328-2.328Z",
    transform: "translate(0 -0.004)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgX);
export default __webpack_public_path__ + "static/media/x.5b43037d869bcf9ef65e1f5246df18c8.svg";
export { ForwardRef as ReactComponent };